import * as React from 'react';

import {
  EAddressCadastreSpecialFlowValidationErrorCodes,
  EInputMode,
  IAddressCadastreCustomError,
  IUseAddressCadastreCustomErrorProps,
} from '../types';
import { isAddressCadastreSpecialFlowValidationErrorCode } from './isAddressCadastreSpecialFlowValidationErrorCode';
import { CadastreNotFoundAlert } from '../components/CadastreNotFoundAlert';
import { AddressNotFoundAlert } from '../components/AddressNotFoundAlert';
import { AddressHasManyCadastreAlert } from '../components/AddressHasManyCadastreAlert';

export function useAddressCadastreCustomError({
  error,
  inputMode,
  onInputModeChange,
}: IUseAddressCadastreCustomErrorProps): IAddressCadastreCustomError {
  const setCadastreInputMode = React.useCallback(() => onInputModeChange(EInputMode.Cadastre), [onInputModeChange]);

  if (!error) {
    return {};
  }

  if (!isAddressCadastreSpecialFlowValidationErrorCode(error)) {
    return inputMode === EInputMode.Address ? { address: error } : { cadastre: error };
  }

  switch (error) {
    case EAddressCadastreSpecialFlowValidationErrorCodes.AddressNotFound:
      return {
        custom: <AddressNotFoundAlert />,
      };
    case EAddressCadastreSpecialFlowValidationErrorCodes.CadastreNotFound:
      return {
        custom: <CadastreNotFoundAlert />,
      };
    case EAddressCadastreSpecialFlowValidationErrorCodes.AddressHasManyCadastre:
      return {
        custom: <AddressHasManyCadastreAlert onAction={setCadastreInputMode} />,
      };
  }
}
